interface AssistantIconProps {
  width?: number | string
  height?: number | string
  color?: string
  className?: string
}

// The star sparkle AI mark — the single glyph for the assistant and AI features.
const AssistantIcon = ({ width = 16, height = 16, color = 'currentColor', className }: AssistantIconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="assistant-icon"
      aria-hidden="true"
    >
      <path
        d="M3.25 20.75V15.75M3.25 5.75V0.75M0.75 3.25H5.75M0.75 18.25H5.75M11.75 1.75L10.0158 6.25886C9.73381 6.99209 9.5928 7.35871 9.37353 7.66709C9.17919 7.9404 8.9404 8.17919 8.66709 8.37353C8.35871 8.59281 7.99209 8.73381 7.25886 9.01582L2.75 10.75L7.25886 12.4842C7.99209 12.7662 8.35871 12.9072 8.66709 13.1265C8.9404 13.3208 9.17919 13.5596 9.37353 13.8329C9.59281 14.1413 9.73381 14.5079 10.0158 15.2411L11.75 19.75L13.4842 15.2411C13.7662 14.5079 13.9072 14.1413 14.1265 13.8329C14.3208 13.5596 14.5596 13.3208 14.8329 13.1265C15.1413 12.9072 15.5079 12.7662 16.2411 12.4842L20.75 10.75L16.2411 9.01582C15.5079 8.73381 15.1413 8.5928 14.8329 8.37353C14.5596 8.17919 14.3208 7.9404 14.1265 7.66709C13.9072 7.35871 13.7662 6.99209 13.4842 6.25886L11.75 1.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AssistantIcon
